app
    .controller('preViewCtrl', function ($rootScope, $scope, $q, _API_URL, $state, $window, shareData, modalFactory, modalService, $filter, urlServices, _VAR_GLOBAL, toaster, $location) {
        $scope.filter = '';
        $scope.dataList = {
            totalItems: 0,
            summary:{},
            data: []
        };
        $scope.paginationOptions = {
            pageNumber: 1,
            pageSize: _VAR_GLOBAL.limit,
            sort: null
        };
        $scope.currentStatusFilter = null;
        $scope.listMode = 'RECEIVE_DOC';
        $scope.perTglP = {
            startDate: moment().subtract(30, 'days'),
            endDate: moment()
        };
        $scope.edit=function(dt){
            console.log(dt);
            return window.location=_API_URL+'purchasing?screen=pr&isedit=true&prno='+ dt.NoBukti;
            
        };
        $scope.refreshData=function(){
            return $scope.viewData(1,$scope.currentStatusFilter);
        };
        $scope.hapus=function(dt){
            console.log(dt);
            $scope.NoBukti=dt.NoBukti;
            modalService.showModal({}, {
                closeButtonText: 'No',
                actionButtonText: 'Yes',
                headerText: 'Hapus PR',
                bodyText: 'Anda yakin ingin menghapus PR ' + dt.NoBukti + ' ?'
            })
            .then(function (result) {
                if (result) {
                    urlServices.hapusData('api/purchase-requisition?prno='+ $scope.NoBukti,{}, function (g, s) {
                        if (g) {
                            if (g && g.err && g.err instanceof Array) {
                                console.log('error');
                                $scope.errorMessage = g.err;
                                var elP = '';
                                for (var key in $scope.errorMessage) {
                                    elP +=  $scope.errorMessage[key].msg;
                                }
                                console.log(elP)
                                toaster.pop('error', 'error data', elP);
        
        
                            } else {
                                toaster.pop('error', 'error data', g.err);
                            
        
                            }
                        } else {
                            
                            toaster.pop('success', 'Success', 'Data dihapus');
                            $scope.refreshData();
                            
        
        
                        }
                    })

                }
            })
            
        };

         

        $scope.viewData = function (pg, qry) {
            if (typeof qry !== 'undefined') {
                $scope.currentStatusFilter = qry;
            }
            $scope.paginationOptions.pageNumber = pg || 1;
            if ($scope.currentStatusFilter === 'NOT_RECEIVED') {
                $scope.listMode = 'PO_NOT_RECEIVED';
                $scope.getDataPoReceive($scope.filter, 'NOT_RECEIVED');
            } else {
                $scope.listMode = 'RECEIVE_DOC';
                $scope.getData($scope.paginationOptions.pageSize, $scope.paginationOptions.pageNumber, $scope.filter, $scope.currentStatusFilter);
            }
        };
        $scope.detail=function(n){
            modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                functionName: 'preViewList',
                params: {
                    no:n.NoBukti
                }
            });
        };
		$scope.viewDashboard = function () {
            urlServices.ambilData('api/preceive/summary?start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd"), {}, function (e, s) {
                console.log('dashboard');
                console.log(s);
                console.log(e);
                if (e) {
                    $scope.dataList.summary={};
                } else {
                    $scope.dataList.summary=s[0];
                }
            });
        };
        $scope.getDataPoReceive = function (searchText, status, pageNum) {
            var pageNum = pageNum || $scope.paginationOptions.pageNumber;
            var data = 'status=' + (status || 'NOT_RECEIVED') + '&start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd");
            data += '&limit=' + $scope.paginationOptions.pageSize + '&pg=' + pageNum;
            if (searchText) {
                data += '&term=' + encodeURIComponent(searchText.toLowerCase());
            }
            var doSummary = (pageNum === 1);
            if (doSummary) {
                $q.all({
                    summary: urlServices.ambilDataPromise('api/preceive/summary?start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd"), {}),
                    list: urlServices.ambilDataPromise('api/preceive/po?' + data, {})
                }).then(function (results) {
                    $scope.dataList.summary = results.summary[0] || {};
                    if (results.list && typeof results.list.count === 'number') {
                        $scope.dataList.totalItems = results.list.count;
                        $scope.dataList.data = results.list.rows || [];
                    } else {
                        $scope.dataList.totalItems = (results.list && results.list.length) || 0;
                        $scope.dataList.data = (results.list && results.list.data) || results.list || [];
                    }
                }, function (err) {
                    $scope.dataList.totalItems = 0;
                    $scope.dataList.data = [];
                });
            } else {
                urlServices.ambilData('api/preceive/po?' + data, {}, function (err, result) {
                    if (err) { $scope.dataList.data = []; return; }
                    if (result && typeof result.count === 'number') {
                        $scope.dataList.totalItems = result.count;
                        $scope.dataList.data = result.rows || [];
                    } else {
                        $scope.dataList.totalItems = (result && result.length) || 0;
                        $scope.dataList.data = (result && result.data) || result || [];
                    }
                });
            }
        };
        $scope.getData = function (pageSize, page, searchText, qry) {
            var qry = qry || null;
            var data;
            if (searchText) {
                var ft = searchText.toLowerCase();
                data = 'term=' + ft + '&limit=' + pageSize + '&pg=' + page + '&start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd");
                if (qry) data += '&status=' + qry;
            } else {
                data = 'limit=' + pageSize + '&pg=' + page + '&start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd");
                if (qry) data += '&status=' + qry;
            }
            var doSummary = (page === 1);
            if (doSummary) {
                $q.all({
                    summary: urlServices.ambilDataPromise('api/preceive/summary?start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd"), {}),
                    list: urlServices.ambilDataPromise('api/preceive/filter?' + data, {})
                }).then(function (results) {
                    $scope.dataList.summary = results.summary[0] || {};
                    $scope.dataList.totalItems = results.list.records || 0;
                    $scope.dataList.data = results.list.data || [];
                }, function (err) {
                    toaster.pop('error', 'Error', err);
                    $scope.dataList.totalItems = 0;
                    $scope.dataList.data = [];
                });
            } else {
                urlServices.ambilData('api/preceive/filter?' + data, {}, function (err, result) {
                    if (err) { toaster.pop('error', 'Error', err); $scope.dataList.data = []; return; }
                    $scope.dataList.totalItems = result.records || 0;
                    $scope.dataList.data = result.data || [];
                });
            }
        };
        $scope.receivePO=function(dt){
            return window.location=_API_URL+'poreceive-entry?po=true&pono='+ dt.NoBukti;
        };
        $scope.$watch('perTglP', function (newDate) {
            //console.log('New date set: ', newDate);
            $scope.viewData(1,$scope.currentStatusFilter);

        }, false);

        $scope.cancelReceive = function (n) {
            var reason = prompt('Masukkan alasan cancel receive ' + n.NoBukti + ':');
            if (!reason || !reason.trim()) {
                toaster.pop('warning', 'Peringatan', 'Alasan cancel wajib diisi');
                return;
            }
            modalService.showModal({}, {
                closeButtonText: 'Batal',
                actionButtonText: 'Ya, Cancel',
                headerText: 'Cancel Receive',
                bodyText: 'Cancel receive: ' + n.NoBukti + ' (PO: ' + n.NOPO + ')\nAlasan: ' + reason
            }).then(function (result) {
                if (result) {
                    urlServices.simpanData('api/preceive/' + encodeURIComponent(n.NoBukti) + '/cancel', { reason: reason }, function (g, s) {
                        if (g) {
                            var errMsg = (g && g.err) ? (typeof g.err === 'string' ? g.err : JSON.stringify(g.err)) : 'Cancel gagal';
                            toaster.pop('error', 'Error', errMsg);
                        } else {
                            toaster.pop('success', 'Berhasil', 'Receive berhasil di-cancel');
                            $scope.viewData(1, $scope.currentStatusFilter);
                        }
                    });
                }
            });
        };

        $scope.viewData(1);
    })

